export const JCPENNEY_TITLE = 'JCPenney';
export const DELIVERY_METHOD_LABEL = 'Delivery Method';
export const SHIPPING_METHOD_LABEL = 'Shipping Method';
export const DIGITAL_DELIVERY_METHOD = 'Email';
export const PASSWORD = 'Password';
export const FORGOT_PASSWORD = 'Forgot Password';
export const NEW_FORGOT_PASSWORD = 'Forgot Password?';
export const SIGN_IN = 'Sign In';
export const REMEMBER_ME = 'Remember Me';
export const SIGN_IN_REWARDS_TITLE =
    'Sign in below to access and apply Rewards from your jcp.com account.';
export const SIGN_IN_BONUS_BUCKS_REWARDS_TITLE =
    'Sign in below to access and apply<br/> JCPenney Bonus Bucks or Rewards from<br/> your account.';
export const NON_DIGITAL_DELIVERY_METHOD = 'Mail';
export const PROTECTION_TITLE_NAME = 'Protection Plans';
export const RECOMMENDED_PRODUCT_LABEL = 'Usually purchased with this item';
export const PARTS_AND_SERVICE_TITLE_LABEL = 'Parts & Services';
export const APPLIANCE_INSTALLATION_LABEL = 'Appliance Installation';
export const DELIVERY_SERVICE_TITLE_LABEL = 'Delivery Services';
export const PROTECTION_PLAN_ASSISTANCE =
    'Our plans provide additional protection for your purchase.';
export const PROTECT_YOUR_PURCHASE = 'Protect Your Purchase';
export const BELOW_PURCHASE_TEXT = 'Usually purchased with this item';
export const PURCHASE_IS_PROTECTED = 'Your Purchase is Protected';
export const TOTAL_LABEL = 'Total';
export const TOTAL_BEFORE_TAX = 'Total Before Tax';
export const PANEL_TITLE = 'Back';
export const OC_ACCOUNT_CREATION_NOTE =
    "We've saved your information, sign up by simply entering a phone number & password for";
export const OC_ITEM_DELIVERY_SUMMARY = {
    HOME: {
        label: 'Ship to Home',
        desc: 'Est. Delivery',
    },
    STORE: {
        label: 'Ship to Store',
        desc: 'Est. Delivery',
    },
    BOPIS: {
        label: 'Same Day Pickup',
        desc: 'Pickup today at',
    },
};
export const CREATE_ACCOUNT = 'Create Account';
export const CONTINUE_SHOPPING = 'Continue Shopping';
export const BACK_TO_SEARCH = 'Back to search results';
export const EDIT_CART = 'Edit Cart';
export const SFL_MODAL_EDIT = 'Edit';
export const SFL_MODAL_CLOSE = 'Close';
export const CREATE_ACCOUNT_SUCCESS_MESSAGE = "A confirmation email is on it's way to  ";
export const SET_EXPRESS_CHECKOUT = 'Set Express Checkout';
export const SAVE_DEFAULT_PAYMENT = 'Save default payment and shipping info for future purchases.';
export const YOU_SAVED_LABEL = 'You Saved';
export const TOTAL_SAVINGS = 'Total Savings';
export const ENTER_PASSWORD = "We've saved your information, simply enter password.";
export const offeringLabels = {
    YES: 'Yes',
    NO: 'No',
    NO_THANK_YOU: 'No, thank you',
};
export const NO_OFFERINGS_AVAILABLE =
    'No additional parts, services and protection plans available for this item.';
export const RECYCLE_FEE_MAY_APPLY = 'Recycle fee may apply';
export const DISPOSABLE_FEE_MAY_APPLY = 'Disposal fee may apply';
export const RECYCLE_FEE = 'Recycle Fee';
export const DISPOSABLE_FEE = 'Disposal Fee';
export const LIMITED_WARRANTY = 'Limited warranty included';
export const SEE_DETAILS = 'Details';
export const SEE_DETAILS_LABEL = 'See Details';
export const ENTER_COUPON_OR_REWARD = 'Enter coupon or reward';
export const ENTER_COUPON_OR_REWARD_UI = 'Coupon or Reward Code';
export const ENTER_COUPON_JCPBUCKS_OR_REWARD = 'Enter Coupon, JCP Rewards, or Bonus Bucks';
export const ENTER_COUPON_OR_REWARD_OR_GIFT = 'Coupon, Reward, or Gift Card';
export const REMOVE = 'Remove';
export const EDIT = 'Edit';
export const REMOVE_REWARDS = 'Apply/Remove';
export const FREE = 'FREE';
export const DISCOUNT = 'Discount:';
export const COUPON = 'Coupon:';
export const COUPON_AND_REWARDS = 'Coupons & Rewards:';
export const REWARDS = 'Rewards:';
export const BONUS_BUCKS_OR_REWARDS = 'JCP Rewards/<br/>Bonus Bucks:';
export const JCP_LABEL = 'JCP ';
export const JCP_BONUS_BUCKS_REWARDS_LABEL = 'JCP Rewards/';
export const BONUS_BUCKS_OR_REWARDS_APPLIED = 'Bonus Bucks';
export const APPLY_COUPON = 'Apply Coupon';
export const APPLY_REWARD = 'Apply Reward';
export const APPLY_REWARDS = 'Apply Rewards';
export const APPLY_BONUS_BUCKS_OR_REWARDS = 'Apply JCPenney Bonus Bucks or Rewards';
export const APPLY = 'Apply';
export const CANCEL = 'Cancel';
export const CONTINUE = 'Continue';
export const ESTIMATED_AT_CHECKOUT = ' Estimated at checkout';
export const CHECKOUT = 'CHECKOUT';
export const ANY_CHANGES_MKAE_EFFECT_DELIVERY_DATE =
    'Any changes you make to your delivery date will apply to all items in your cart.';
export const EARLIEST_AVAILABLE_DELEVERY = 'Earliest available delivery to';
export const CHANGE_DELIVERY_DATE = 'Change Delivery Date';
export const FIND_BEST_COUPON = 'FIND BEST COUPON';
export const CONTINUE_AS_GUEST = 'Continue as Guest';
export const CHECKOUT_AS_GUEST = 'Checkout as Guest';
export const GUEST_CHECKOUT = 'Continue as Guest';
export const CREATE_ACCOUNT_AFTER_CHECKOUT =
    'You can create an account after checkout is complete.';
export const INTERSTITIAL_CAREPLAN = {
    DONE: 'Done',
    RETURN_TO_SEARCH: '< Return to search results',
    CHECKOUT: 'Checkout',
    ITEM_ADDED: ' Item Added to Cart',
    ITEMS_ADDED: ' Items Added to Cart',
    ITEM_ADD_MSG: ' Item Added',
    ITEMS_ADD_MSG: ' Items Added',
    ADDN_PROTECTION_PLAN: 'Additional Protection Plan',
    NO_THANK_YOU: 'No Thank you',
    VIEW_CART_AND_CHECKOUT: 'View Cart & Checkout',
};
export const ADDITIONAL_SERVICES_OPTIONS = {
    ADD: 'Add',
    EDIT: 'Edit',
    REMOVE: 'Remove',
};
export const ADDITIONAL_PROTECTION = 'Additional Protection';
export const OPTIONAL_SERVICES = 'Optional Services';
export const OPTIONAL_SERVICES_DESC = 'Optional services for your delivery.';
export const WARRANTY_TEXT = 'Extended warranty and protection options for your purchase.';
export const WARRANTY_NEW_TEXT = 'Additional protection for your purchase.';
export const ADD_GIFT_CARD = 'Add a Gift Card';
export const ADD_ANOTHER_GIFT_CARD = 'Add Another Gift Card';
export const GC_FORM_CARD_PLACEHOLDER = 'Gift Card Number';
export const GC_FORM_CODE_PLACEHOLDER = 'Enter Security Code';
export const GC_PIN_CODE_PLACEHOLDER = 'PIN';
export const GC_BALANCE = 'Remaining on Card';
export const GC_FROM_WALLET = 'Gift Cards from Wallet';
export const GC_CTA_MESSAGE_1 = 'There is a remaining balance of ';
export const GC_CTA_MESSAGE_2 = '. Please add another form of payment.';
export const PROMO_FINANCING_WARNING_MSG =
    'You have chosen promotional financing that requires you pay with your JCPenney Credit Card.' +
    ' Please choose this card if you want to keep your financing.';
export const PROMO_FINANCING_TITLE = 'Special Financing is Available';
export const PROMO_FINANCING_BODY =
    'Making changes to your payment type and/or cart items may change the availability of special financing offers.' +
    ' This offer will be applied to your entire order with the exception of any gift card purchases.';
export const REWARD_OR_PROMO_FINANCING_TITLE = 'Off Discount or Special Financing';
export const REWARD_OR_PROMO_FINANCING_BODY = {
    SENTENCE1: 'You can either choose',
    SENTENCE2:
        'Off Discount or Special Financing on your order. If you wish to use the Special Financing, then the',
    SENTENCE3: 'Off Discount will be removed.',
};
export const PROMO_FINANCING_LABEL = 'Select an offer to view terms and conditions';
export const REWARD_OR_SPECIAL_FINACING_DESC = {
    SENTENCE1: 'If you wish to use the',
    SENTENCE2: 'Off Discount, then the Special Financing will be removed from your order.',
};
export const FINANCING_REMOVED = 'Special Financing was removed.';
export const ELECTRONIC_CONSENT = 'Electronic Consent';
export const ACCEPT_AND_CONTINUE = 'Accept and Continue';
export const NO_THANKS = 'No Thanks';
export const DECLINE_SPECIAL_FINANCING = 'Decline Special Financing';
export const ACCEPT_TERMS_CHECKBOX_LABEL = 'I accept the Terms and Conditions';
export const NORTON_SECURITY_BADGE_LABEL = 'Shop safe with JCPenney';
export const BILLING_INFORMATION = 'Billing Information';
export const CONTACT_INFORMATION = 'Contact Information';
export const PAYMENT = 'Payment';
export const PAYMENT_INFORMATION = 'Payment Information';
export const GIFT_CARD = 'Gift Card';
export const MAX_TWO_GC_WARNING = 'NOTE: There’s a limit of 2 gift cards per order.';
export const ADD_GC_TITLE = 'Add a New Gift Card';
export const GC_TITLE = 'Gift Cards';
export const TRANSACTION_SMS = 'Text me order status updates';
export const REVIEW_PAGE_TITLE = 'Review Order';
export const REMAINING_BALANCE = 'Remaining Balance';
export const PLACE_ORDER = 'Place Order';
export const RETURN_TO_SIGNIN = 'Return to Sign In';
export const SIGN_IN_TO_ACCOUNT = 'Sign in to your account';
export const SIGNIN_TO_APPLY_REWARDS = 'Sign In to Apply Your Rewards';
export const ENTER_COUPONS_OR_REWARDS = 'Enter Coupons or Rewards';
export const APPLIED = 'Applied';
export const EXPIRATION = 'EXPIRATION';
export const REWARD_TYPE = 'REWARD TYPE';
export const ENTER_REWARDS = 'Enter Rewards';
export const ENTER_BONUS_BUCKS_OR_REWARDS = 'Enter JCPenney Bonus Bucks or Rewards';
export const ROUND_UP_DETAILS = 'Details';
export const ERRORS = {
    INVALID_PHONE_MSG: 'Enter a valid phone number',
    INVALID_MOBILE_MSG: 'Enter a valid mobile number',
    INVALID_EMAIL_MSG: 'Please enter a valid email address',
    EMPTY_EMAIL_OR_PHONE: 'Enter a valid email address or phone number',
    EMPTY_VALID_PASSWORD: 'Enter a valid password',
    EMPTY_EMAIL: 'Please enter a valid email address',
    EMPTY_PASSWORD: 'Enter a password',
    EMPTY_COUPON: 'Please enter a valid code.',
    EMPTY_SERIAL_CODE: 'Enter a serial number',
    REWARDS_NOT_AVAILABLE: 'Rewards are not available at this time. Please try again later',
};
export const FORM_FIELDS = {
    PHONE_LABEL: 'Phone Number',
    ALT_PHONE_LABEL: 'Alt Phone Number',
    MOBILE_LABEL: 'Mobile Number',
    REASON: 'Why do we need this?',
    PROMOTIONAL_CONSENT_TEXT:
        'Yes, sign me up to receive email offers, sales, coupons and more from JCPenney, its affiliates and licensees.',
};
export const CARDNUMBERRENTRYREQUIRED_AUTH = {
    TITLE: 'Please re-enter payment',
    MESSAGE:
        'You recently updated your account information. For your security, please confirm the payment method on your account by re-entering your credit card number.',
};
export const UNVERIFIED_AUTH = {
    TITLE: 'Please re-enter payment',
    MESSAGE: {
        jcpenneymastercard:
            'Additional details are needed regarding your JCPenney credit card. For help, please call JCPenney Credit at 1-800-527-4403, or you could choose to select a different method of payment.',
        other:
            "Oops. We're having trouble processing this card. Double check the card information you entered or try another method of payment",
        CVVAuthFailMessage:
            'For your security, additional information is necessary to verify this credit card. Please enter the card verification value (CVV) below.',
    },
};
export const TEMPCARDNUMBERRENTRYREQUIRED_AUTH = {
    TITLE: 'Please re-enter payment',
    MESSAGE:
        'For your security, please confirm the payment method on your account by re-entering your credit card number',
};
export const CARD_AUTH_FAILD_ERROR = {
    TITLE: 'Please re-enter payment',
    errorCode: 'SRV_AUTH_FAILED_CREDIT_CARD_REENTER_REQUIRED',
    errorMessage:
        'We see that you haven’t used this card in a while. For your security, please re-enter the card information or use another card.',
};
export const MANUAL_REWARD_MESSAGE =
    'This code was manually entered. If you remove it, you’ll need to enter it again.';
export const PREVIOUS = 'Previous';
export const NEXT = 'Next';
export const CHECKOUT_LOWERCASE = 'Checkout';
export const TOOLTIP = {
    CONTACT_EMAIL: 'We’ll use this email to send your order confirmation email.',
    CONTACT_PHONE: 'We’ll use this phone number to<br/> communicate important order information.',
};
export const COUPONS_APPLIED_LABEL = 'Coupon Applied';
export const DISCOUNT_APPLIED_LABEL = 'Discount Applied';
export const DISCOUNT_APPLIED_MESSAGE_TEXT =
    'Please use your JCPenney Credit Card in checkout to get this savings.';
export const COUPONS_APPLIED_NOT_QUALIFIED_LABEL = 'Coupon Applied, But...';
export const REWARDS_APPLIED_LABEL = 'Reward Applied';
export const BONUS_BUCKS_REWARDS_APPLIED_LABEL = 'JCPenney Bonus Bucks or Reward Applied';
export const SERIAL_APPLY_LABEL = 'Apply Number';
export const SERIAL_CANCEL_LABEL = 'Cancel';
export const OK_LABEL = 'Ok';
export const OK_GOT_IT = 'OK, got it';
export const RESET_PASSWORD = 'Hey, It Happens';
export const RESET_PASSWORD_BTN = 'Send';
export const RESET_PASSWORD_SUBTITLE =
    "Enter the email address for your account and we'll send instructions for changing your password.";
export const EMAIL = 'Email';
export const EMAIL_OR_PHONE = 'Email or Mobile Number';
export const RESET_SENT = 'Check Your Inbox!';
export const RESET_SENT_SUBTITLE = 'Instructions have been sent to';
export const SPAM_FOLDER_CHECK = 'Make sure to check your spam folder.';
export const RESEND_EMAIL = 'Resend Email';
export const BACK_TO_SIGN_IN = 'Back to Sign In';
export const RESET_INFO_TITLE = 'Having trouble accessing your account?';
export const RESET_INFO_TEXT = 'If you’re unable to change your password, ';
export const RESET_INFO_SERVICEINFO = 'please call our Customer Care team at';
export const RESET_INFO_SERVICEINFO_NUMBER = '1 (800) 322-1189.';
export const BACK_TO_CART = 'Back';
export const BACK_TO_CO = 'Back to checkout';
export const ITEM_DETAILS = 'Item Details';
export const ORDER_DETAILS = 'Order Details';
export const BACK_TO_SHOPPING_CART = 'Back to shopping cart';
export const PLCC_BANNER = {
    BANNER_HEADING: 'Apply for a JCPenney Credit Card',
    BANNER_TEXT: 'Faster rewards, financing & more savings',
    BANNER_LABEL: 'Learn More to Apply',
};
export const GIFT_REGISTRY = {
    FOR: 'Gift Item for ',
    INFORMATION: 'Gift registry items can only be shipped to a single address per order.',
};
export const GIFT_CARD_PAGE = {
    PAGE_HEADING: 'Check Gift Card Balance',
};
export const OOS_MESSAGES = {
    TITLE: 'Out of Stocks Items',
    BODY:
        'One or more items have become out of stock, and will be removed when you checkout. You can edit the item to see if other product options are available. Same Day pick up items may be available at other stores',
};
export const DISCONTINUED_OOS_MESSAGES = {
    DISCONTINUED_ITEMS: {
        TITLE: 'Discontinued Items',
        BODY: 'One or more items are now discontinued and no longer available for purchase.',
    },
    DISCONTINUE_OOS_NOSDPU: {
        TITLE: 'Out of Stocks Items',
        BODY:
            'One or more items in your cart are either out of stock or discontinued and will be removed if you checkout. Edit any item to find available product options.',
    },
    DISCONTINUE_OOS_SDPU: {
        TITLE: 'Out of Stocks Items',
        BODY:
            'One or more items in your cart are either out of stock or discontinued and will be removed if you checkout. Edit any item to find available product options. Same Day Pick Up Items may be available at other stores.',
    },
    OOS_SDPU: {
        TITLE: 'Out of Stocks Items',
        BODY:
            'One or more items have become out of stock, and will be removed if you checkout. You can edit the item to see if other product options are available. Same Day Pickup items may be available at other stores.',
    },
    OOS_NOSDPU: {
        TITLE: 'Out of Stocks Items',
        BODY:
            'One or more items are out of stock and will be removed if you checkout. Edit any item to find available product options.',
    },
};
export const FINANCING_SUCCESS_MESAAGE = 'Successfully added special financing to your order.';
export const DISCOUNT_REMOVED_MESSAGE = 'Off Discount was removed';
export const BILLING_ADDRESS_SAME = 'My shipping and billing address is the same';
export const IMPORTANT_PROMOTIONAL_INFORMATION = 'Important Promotional Information';
export const COUPON_DETAILS = 'Details';
